import { render, staticRenderFns } from "./container-columns.vue?vue&type=template&id=6632bc21&scoped=true&"
import script from "./container-columns.vue?vue&type=script&lang=js&"
export * from "./container-columns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6632bc21",
  null
  
)

export default component.exports